module.exports = __webpack_public_path__ + "img/dienteProt.996d722c.svg";